import React from 'react';
import { Container } from 'reactstrap';

const ContentfulTextWithImage = ({ entry }) => (
  <Container>{entry.id}</Container>
);

export default ContentfulTextWithImage;
